window.callbackThen = (response) => {
    // read HTTP status
    console.log(response.status);

    // read Promise object
    response.json().then(function(data){
        if(data.success && data.score >= 0.6) {
            console.log('valid recaptcha');
        } else {
            document.querySelector('#authForm').addEventListener('submit', function(event) {
                event.preventDefault();
                alert('recaptcha error');
            });
            document.querySelector('#authForm button[type=submit]').disabled = true;
            document.querySelector('#alert-recaptche').classList.remove('d-none');
        }
    });
}
window.callbackCatch = (error)=> {
    console.error('Error:', error)
}
